import { ADMIN_PANEL_PATHS } from '@components/Admin/Modules/paths'
import { ROUTER_PATHS } from '@utils/constants/routerPaths'

export const ORDER_PERMISSION_PREFIX = 'order.'

export const PERMISSIONS = {
  // Order
  ORDER_MANAGE: 'order.manage',
  ORDER_SUPERVISE: 'order.supervise',
  ORDER_CREATE: 'order.create',
  ORDER_UPDATE: 'order.update',
  ORDER_VIEW: 'order.view',
  // Order Label
  ORDER_LABEL_MANAGE: 'order_label.manage',
  ORDER_LABEL_SUPERVISE: 'order_label.supervise',
  // Order Variant
  ORDER_VARIANT_MANAGE: 'order_variant.manage',
  ORDER_VARIANT_VIEW: 'order_variant.view',
  // Order Process
  ORDER_PROCESS_MANAGE: 'order_process.manage',
  ORDER_PROCESS_VIEW: 'order_process.view',
  // Production Order
  PRODUCTION_ORDER_MANAGE: 'production_order.manage',
  PRODUCTION_ORDER_SUPERVISE: 'production_order.supervise',
  PRODUCTION_ORDER_CREATE: 'production_order.create',
  PRODUCTION_ORDER_VIEW: 'production_order.view',
  // Production Order Process
  PRODUCTION_ORDER_PROCESS_MANAGE: 'production_order_process.manage',
  PRODUCTION_ORDER_PROCESS_SUPERVISE: 'production_order_process.supervise',
  PRODUCTION_ORDER_PROCESS_VIEW: 'production_order_process.view',
  // Marker
  MARKER_MANAGE: 'marker.manage',
  MARKER_SUPERVISE: 'marker.supervise',
  MARKER_CREATE: 'marker.create',
  MARKER_SIZE_MATRIX_MANAGE: 'marker_size_matrix.manage',
  // Bundle
  BUNDLE_MANAGE: 'bundle.manage',
  BUNDLE_SUPERVISE: 'bundle.supervise',
  BUNDLE_VIEW: 'bundle.view',
  BUNDLE_TEMPLATE_MANAGE: 'bundle_template.manage',
  BUNDLE_TEMPLATE_SUPERVISE: 'bundle_template.supervise',
  // Cutting Action
  CUTTING_ACTION_MANAGE: 'cutting_action.manage',
  CUTTING_ACTION_SUPERVISE: 'cutting_action.supervise',
  CUTTING_ACTION_CREATE: 'cutting_action.create',
  // Size Matrix
  SIZE_MATRIX_MANAGE: 'size_matrix.manage',
  SIZE_MATRIX_SUPERVISE: 'size_matrix.supervise',
  SIZE_MATRIX_VIEW: 'size_matrix.view',
  // Season
  SEASON_MANAGE: 'season.manage',
  SEASON_SUPERVISE: 'season.supervise',
  SEASON_CREATE: 'season.create',
  SEASON_VIEW: 'season.view',
  // Production Unit
  PRODUCTION_UNIT_MANAGE: 'production_unit.manage',
  PRODUCTION_UNIT_SUPERVISE: 'production_unit.supervise',
  // Client
  CLIENT_MANAGE: 'client.manage',
  CLIENT_SUPERVISE: 'client.supervise',
  // Base Process
  BASE_PROCESS_MANAGE: 'base_process.manage',
  BASE_PROCESS_SUPERVISE: 'base_process.supervise',
  // File Category
  FILE_CATEGORY_MANAGE: 'file_category.manage',
  FILE_CATEGORY_SUPERVISE: 'file_category.supervise',
  // Machine Type
  MACHINE_TYPE_MANAGE: 'machine_type.manage',
  MACHINE_TYPE_SUPERVISE: 'machine_type.supervise',
  // Garment Family
  GARMENT_FAMILY_MANAGE: 'garment_family.manage',
  GARMENT_FAMILY_SUPERVISE: 'garment_family.supervise',
  // Garment Type
  GARMENT_TYPE_MANAGE: 'garment_type.manage',
  GARMENT_TYPE_SUPERVISE: 'garment_type.supervise',
  GARMENT_TYPE_CREATE: 'garment_type.create',
  // Size Standard
  SIZE_STANDARD_MANAGE: 'size_standard.manage',
  SIZE_STANDARD_SUPERVISE: 'size_standard.supervise',
  // Team
  TEAM_MANAGE: 'team.manage',
  TEAM_SUPERVISE: 'team.supervise',
  // Attribute Definition
  ATTRIBUTE_DEFINITION_MANAGE: 'attribute_definition.manage',
  ATTRIBUTE_DEFINITION_SUPERVISE: 'attribute_definition.supervise',
  ATTRIBUTE_DEFINITION_CREATE: 'attribute_definition.create',
  // Calendar
  CALENDAR_MANAGE: 'calendar.manage',
  CALENDAR_SUPERVISE: 'calendar.supervise',
  // Work Record
  WORK_RECORD_MANAGE: 'work_record.manage',
  WORK_RECORD_VIEW: 'work_record.view',
  // Shop Floor Plan
  SHOP_FLOOR_PLAN_MANAGE: 'shop_floor_plan.manage',
  SHOP_FLOOR_PLAN_SUPERVISE: 'shop_floor_plan.supervise',
  SHOP_FLOOR_PLAN_VIEW: 'shop_floor_plan.view',
  // Earning Rate
  EARNING_RATE_MANAGE: 'earning_rate.manage',
  // Cutting Material Type
  CUTTING_MATERIAL_TYPE_MANAGE: 'cutting_material_type.manage',
  CUTTING_MATERIAL_TYPE_SUPERVISE: 'cutting_material_type.supervise',
  // Defect Severity
  DEFECT_SEVERITY_MANAGE: 'defect_severity.manage',
  DEFECT_SEVERITY_SUPERVISE: 'defect_severity.supervise',
  // Defect Category
  DEFECT_CATEGORY_MANAGE: 'defect_category.manage',
  DEFECT_CATEGORY_SUPERVISE: 'defect_category.supervise',
  // Defect Type
  DEFECT_TYPE_MANAGE: 'defect_type.manage',
  DEFECT_TYPE_SUPERVISE: 'defect_type.supervise',
  // Reports
  OPERATOR_EFFICIENCY_REPORT_MANAGE: 'operator_efficiency_report.manage',
  INCOME_REPORT_MANAGE: 'income_report.manage'
}

export const ADMIN_MODULE_PERMISSIONS: Record<
  string,
  { manage: string; access: string[] }
> = {
  [ADMIN_PANEL_PATHS.PRODUCTION_UNIT_TYPES]: {
    manage: PERMISSIONS.PRODUCTION_UNIT_MANAGE,
    access: [
      PERMISSIONS.PRODUCTION_UNIT_MANAGE,
      PERMISSIONS.PRODUCTION_UNIT_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.PRODUCTION_UNIT_LABELS]: {
    manage: PERMISSIONS.PRODUCTION_UNIT_MANAGE,
    access: [
      PERMISSIONS.PRODUCTION_UNIT_MANAGE,
      PERMISSIONS.PRODUCTION_UNIT_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.ORDER_LABELS]: {
    manage: PERMISSIONS.ORDER_LABEL_MANAGE,
    access: [PERMISSIONS.ORDER_LABEL_MANAGE, PERMISSIONS.ORDER_LABEL_SUPERVISE]
  },
  [ADMIN_PANEL_PATHS.PRODUCTION_UNITS]: {
    manage: PERMISSIONS.PRODUCTION_UNIT_MANAGE,
    access: [
      PERMISSIONS.PRODUCTION_UNIT_MANAGE,
      PERMISSIONS.PRODUCTION_UNIT_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.OPERATOR_TYPES]: {
    manage: PERMISSIONS.PRODUCTION_UNIT_MANAGE,
    access: [
      PERMISSIONS.PRODUCTION_UNIT_MANAGE,
      PERMISSIONS.PRODUCTION_UNIT_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.GARMENT_FAMILIES]: {
    manage: PERMISSIONS.GARMENT_FAMILY_MANAGE,
    access: [
      PERMISSIONS.GARMENT_FAMILY_MANAGE,
      PERMISSIONS.GARMENT_FAMILY_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.FILE_CATEGORIES]: {
    manage: PERMISSIONS.FILE_CATEGORY_MANAGE,
    access: [
      PERMISSIONS.FILE_CATEGORY_MANAGE,
      PERMISSIONS.FILE_CATEGORY_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.GARMENT_NODES]: {
    manage: PERMISSIONS.GARMENT_FAMILY_MANAGE,
    access: [
      PERMISSIONS.GARMENT_FAMILY_MANAGE,
      PERMISSIONS.GARMENT_FAMILY_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.SEASONS]: {
    manage: PERMISSIONS.SEASON_MANAGE,
    access: [PERMISSIONS.SEASON_MANAGE, PERMISSIONS.SEASON_SUPERVISE]
  },
  [ADMIN_PANEL_PATHS.MACHINE_TYPES]: {
    manage: PERMISSIONS.MACHINE_TYPE_MANAGE,
    access: [
      PERMISSIONS.MACHINE_TYPE_MANAGE,
      PERMISSIONS.MACHINE_TYPE_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.SIZE_STANDARDS]: {
    manage: PERMISSIONS.SIZE_STANDARD_MANAGE,
    access: [
      PERMISSIONS.SIZE_STANDARD_MANAGE,
      PERMISSIONS.SIZE_STANDARD_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.CLIENTS]: {
    manage: PERMISSIONS.CLIENT_MANAGE,
    access: [PERMISSIONS.CLIENT_MANAGE, PERMISSIONS.CLIENT_SUPERVISE]
  },
  [ADMIN_PANEL_PATHS.PRODUCER]: {
    manage: PERMISSIONS.PRODUCTION_UNIT_MANAGE,
    access: [
      PERMISSIONS.PRODUCTION_UNIT_MANAGE,
      PERMISSIONS.PRODUCTION_UNIT_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.BASE_PROCESSES]: {
    manage: PERMISSIONS.BASE_PROCESS_MANAGE,
    access: [
      PERMISSIONS.BASE_PROCESS_MANAGE,
      PERMISSIONS.BASE_PROCESS_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.OPERATORS]: {
    manage: PERMISSIONS.PRODUCTION_UNIT_MANAGE,
    access: [
      PERMISSIONS.PRODUCTION_UNIT_MANAGE,
      PERMISSIONS.PRODUCTION_UNIT_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.RATES]: {
    manage: PERMISSIONS.EARNING_RATE_MANAGE,
    access: [PERMISSIONS.EARNING_RATE_MANAGE]
  },
  [ADMIN_PANEL_PATHS.ORDER_VARIANT_ATTRIBUTES]: {
    manage: PERMISSIONS.ATTRIBUTE_DEFINITION_MANAGE,
    access: [
      PERMISSIONS.ATTRIBUTE_DEFINITION_MANAGE,
      PERMISSIONS.ATTRIBUTE_DEFINITION_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.CUTTING_MATERIAL_TYPE]: {
    manage: PERMISSIONS.CUTTING_MATERIAL_TYPE_MANAGE,
    access: [
      PERMISSIONS.CUTTING_MATERIAL_TYPE_MANAGE,
      PERMISSIONS.CUTTING_MATERIAL_TYPE_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.TEAMS]: {
    manage: PERMISSIONS.TEAM_MANAGE,
    access: [PERMISSIONS.TEAM_MANAGE, PERMISSIONS.TEAM_SUPERVISE]
  },
  [ADMIN_PANEL_PATHS.BUNDLE_TEMPLATES]: {
    manage: PERMISSIONS.BUNDLE_TEMPLATE_MANAGE,
    access: [
      PERMISSIONS.BUNDLE_TEMPLATE_MANAGE,
      PERMISSIONS.BUNDLE_TEMPLATE_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.CALENDARS]: {
    manage: PERMISSIONS.CALENDAR_MANAGE,
    access: [PERMISSIONS.CALENDAR_MANAGE, PERMISSIONS.CALENDAR_SUPERVISE]
  },
  [ADMIN_PANEL_PATHS.SHOP_FLOOR_TEMPLATES]: {
    manage: PERMISSIONS.SHOP_FLOOR_PLAN_MANAGE,
    access: [
      PERMISSIONS.SHOP_FLOOR_PLAN_MANAGE,
      PERMISSIONS.SHOP_FLOOR_PLAN_SUPERVISE,
      PERMISSIONS.SHOP_FLOOR_PLAN_VIEW
    ]
  },
  [ADMIN_PANEL_PATHS.DEFECT_SEVERITIES]: {
    manage: PERMISSIONS.DEFECT_SEVERITY_MANAGE,
    access: [
      PERMISSIONS.DEFECT_SEVERITY_MANAGE,
      PERMISSIONS.DEFECT_SEVERITY_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.DEFECT_CATEGORIES]: {
    manage: PERMISSIONS.DEFECT_CATEGORY_MANAGE,
    access: [
      PERMISSIONS.DEFECT_CATEGORY_MANAGE,
      PERMISSIONS.DEFECT_CATEGORY_SUPERVISE
    ]
  },
  [ADMIN_PANEL_PATHS.DEFECT_TYPES]: {
    manage: PERMISSIONS.DEFECT_TYPE_MANAGE,
    access: [PERMISSIONS.DEFECT_TYPE_MANAGE, PERMISSIONS.DEFECT_TYPE_SUPERVISE]
  }
}

export const REPORT_ROUTE_PERMISSIONS: Record<string, string> = {
  [ROUTER_PATHS.INCOME_REPORT]: PERMISSIONS.INCOME_REPORT_MANAGE,
  [ROUTER_PATHS.EARNING_REPORT]: PERMISSIONS.INCOME_REPORT_MANAGE,
  [ROUTER_PATHS.PERFORMANCE_REPORT]:
    PERMISSIONS.OPERATOR_EFFICIENCY_REPORT_MANAGE
}

export const getFirstAccessibleAdminModule = (permissionNames: string[]) => {
  const entry = Object.entries(ADMIN_MODULE_PERMISSIONS).find(([, config]) =>
    config.access.some((p) => permissionNames.includes(p))
  )
  return entry?.[0]
}
